<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pPQAMu/tc-custom/9781504099813.jpg?1736624113699" alt="This image is the cover for the book Burn Marks, The V.I. Warshawski Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Burn Marks, The V.I. Warshawski Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A knock at the door in the middle of the night pulls a Chicago PI into a web of crime and corruption in this “captivating” <i>New York Times</i> bestseller (<i>The Baltimore Sun</i>).</b><br/>  <br/> V.I. “Vic” Warshawski’s alcoholic aunt turns up at her door at three in the morning, accompanied by an addict friend after the hotel she’s been living in burns down, and Vic is soon on the trail of an arsonist. But then the private investigator starts getting ominous messages, and her aunt’s friend is found dead . . . with Vic’s driver’s license in their possession. To unravel the mystery and keep herself alive, Vic will have to delve into the dark world of the city’s unhoused population—and the even darker world of Chicago’s wealthy and powerful—in this steely thriller by a winner of multiple Anthony, Edgar, and Dagger Awards.<br/>  <br/> “One gritty good read . . . V.I. is a worthy heir to Marlowe.” —<i>Daily News</i> (New York)<br/>  <br/> “Fast-paced.” —<i>The New York Times Book Review</i><br/>  <br/> “America’s most convincing and engaging professional female private eye.” —<i>Entertainment Weekly</i><br/>  <br/> “V.I. Warshawski is good company.” —<i>Los Angeles Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sara Paretsky
      </h2>
      
      <p class="authorDescription body article">Sara Paretsky is the author of numerous books, including her renowned V. I. Warshawski mysteries. She was named Grand Master in 2011 by the Mystery Writers of America (MWA) and is also the recipient of the Cartier Diamond Dagger Award given by the British Crime Writers&rsquo; Association. Paretsky is credited with transforming the role and image of women in the crime novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5c779786